import { images } from "./helper-objects";

const generateShuffledCards = (numCards) => {
  const values = [...images].sort(() => Math.random() - 0.5).slice(0, numCards);
  const cardPairs = [...values, ...values];
  return cardPairs.sort(() => Math.random() - 0.5);
};

export { generateShuffledCards };
